var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrange(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.69005 7.09992L4.26005 5.66992C3.05005 7.15992 2.25005 8.98992 2.05005 10.9999H4.07005C4.25005 9.53992 4.83005 8.20992 5.69005 7.09992Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9999 4.07078V2.05078C8.98992 2.25078 7.15992 3.05078 5.66992 4.26078L7.09992 5.69078C8.20992 4.83078 9.53992 4.25078 10.9999 4.07078Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.33 4.26078C16.84 3.05078 15.01 2.25078 13 2.05078V4.07078C14.46 4.25078 15.79 4.83078 16.9 5.69078L18.33 4.26078Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9301 10.9999H21.9501C21.7501 8.98992 20.9501 7.15992 19.7401 5.66992L18.3101 7.09992C19.1701 8.20992 19.7501 9.53992 19.9301 10.9999Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13 19.9305V21.9505C15.01 21.7505 16.84 20.9505 18.33 19.7405L16.9 18.3105C15.79 19.1705 14.46 19.7505 13 19.9305Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.66992 19.7405C7.14992 20.9505 8.98992 21.7505 10.9999 21.9505V19.9305C9.53992 19.7505 8.20992 19.1705 7.09992 18.3105L5.66992 19.7405Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.07005 13H2.05005C2.25005 15.01 3.05005 16.84 4.26005 18.33L5.69005 16.9C4.83005 15.79 4.25005 14.46 4.07005 13Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3101 16.9L19.7401 18.33C20.9501 16.85 21.7501 15.01 21.9501 13H19.9301C19.7501 14.46 19.1701 15.79 18.3101 16.9Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17C14.7614 17 17 14.7614 17 12C17 9.23858 14.7614 7 12 7C9.23858 7 7 9.23858 7 12C7 14.7614 9.23858 17 12 17Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrange);
export default __webpack_public_path__ + "static/media/orange.cf5d706ad872bfb875375b27eaec95e8.svg";
export { ForwardRef as ReactComponent };